import { Check } from '@mui/icons-material';
import { Box, Step, StepLabel, Stepper } from '@mui/material';
import type { StepIconProps } from '@mui/material/StepIcon';
import React from 'react';

import { getActiveStepIndex } from 'helpers/applicationRetainers';
import useTranslate from 'hooks/useTranslate';
import type { RetainerFlowStep, RetainerFlowStepKey } from 'types';

const STEP_LABEL_KEYS: Record<RetainerFlowStepKey, string> = {
    case: 'retainerStepCase',
    offer: 'retainerStepOffer',
    serviceAgreement: 'retainerStepServiceAgreement',
    visaRetainer: 'retainerStepVisaRetainer',
    retainer: 'retainerStepRetainer',
    retainers: 'retainerStepRetainers',
};

interface CaseRetainerStepperProps {
    steps: RetainerFlowStep[];
}

/** Completed = filled. Not yet reached = white fill, purple ring and number. */
const RetainerStepIcon: React.FC<StepIconProps> = ({ completed, icon, className }) => (
    <Box
        className={className}
        sx={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 13,
            fontWeight: 700,
            lineHeight: 1,
            ...(completed
                ? { bgcolor: 'primary.main', color: 'common.white' }
                : {
                      bgcolor: 'common.white',
                      color: 'primary.main',
                      border: '2px solid',
                      borderColor: 'primary.main',
                  }),
        }}
    >
        {completed ? <Check sx={{ fontSize: 16 }} /> : icon}
    </Box>
);

export const CaseRetainerStepper: React.FC<CaseRetainerStepperProps> = ({ steps }) => {
    const { translate } = useTranslate();

    if (steps.length === 0) {
        return null;
    }

    return (
        <Stepper
            activeStep={getActiveStepIndex(steps)}
            alternativeLabel
            sx={{ mb: 3, '& .MuiStepLabel-label': { fontWeight: 600 } }}
        >
            {steps.map((step) => (
                <Step key={step.key} completed={step.completed}>
                    <StepLabel StepIconComponent={RetainerStepIcon}>
                        {translate(STEP_LABEL_KEYS[step.key])}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    );
};
